import { useLiveStatus } from '../lib/useLive';
import s from './LiveDot.module.css';

/**
 * The live stream's state, as a dot and a word. Green with `label` while the stream is open; amber
 * "Reconnecting…" once it has dropped, because every number beside it may now be behind — a green
 * "Live" over numbers that stopped moving is the one thing this must never show.
 */
export function LiveDot({ label = 'Live' }: { label?: string }) {
  const status = useLiveStatus();
  if (status === 'live')
    return (
      <span className="live">
        <i />
        {label}
      </span>
    );
  if (status === 'connecting')
    return (
      <span className={`live ${s.liveDotWaiting}`}>
        <i />
        Connecting…
      </span>
    );
  return (
    <span className={`live ${s.liveDotDown}`} title="The live connection dropped. Numbers may be behind until it is back.">
      <i />
      Reconnecting…
    </span>
  );
}
